export const normalizeNumberValue = n => {
  if (n) {
    const u = String(n).replaceAll(',', '')
    return Number(u)
  }
  return n
}
